<script>
    export default {};
</script>

<template lang="pug">
    el-main.p-2
        slot
</template>



// WEBPACK FOOTER //
// src/components/page.vue